import $ from 'jquery';
// Allows the use of jquery outside of app.js
window.jQuery = $;
window.$ = $;

import * as ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import 'slick-carousel';
import objectFitImages from 'object-fit-images';
import ScrollReveal from 'scrollreveal';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

$(function () {
	objectFitImages($('.object-fit'));
	objectFitImages($('.object-contain'));
});

$(window).on('load', function () {
	// When the window loads call the resize function
	windowResize();

	// When the window is resized call the resize function
	$(window).resize(function () {
		windowResize();
	});

	// Scroll reveal ---
	window.sr = ScrollReveal();
	sr.reveal('.fade', { scale: '1', distance: '0px', delay: 250 });
	sr.reveal('.fade-in', { duration: 1050, origin: 'bottom', scale: '1', delay: 250 });
	sr.reveal('.fade-in-app', { duration: 1050, origin: 'bottom', scale: '1', delay: 500 });
	sr.reveal('.fade-down', { duration: 1050, origin: 'top', scale: '1', delay: 250 });
	sr.reveal('.fade-left', { duration: 1050, origin: 'left', scale: '1', delay: 250 });
	sr.reveal('.fade-right', { duration: 1050, origin: 'right', scale: '1', delay: 250 });
	sr.reveal('.fade-in-seq', { duration: 1050, origin: 'bottom', interval: 200, scale: '1', delay: 250 }, 100);
	sr.reveal('.fade-in-seq-footer', { duration: 1050, distance: '0px', origin: 'bottom', interval: 100, scale: '1', delay: 100 }, 100);

	$('.header__burger').on('click', function () {
		$(this).toggleClass('header__burger--open');
		$('.nav-wrapper').toggleClass('nav-wrapper--open');
		$('body').toggleClass('no-scroll');
	});

	$('.header__locations-btn').on('click', function () {
		$(this).siblings('.header-btns__locations-dropdown').toggleClass('header-btns__locations-dropdown--open');
		$(this).toggleClass('header__locations-btn--open');
	});

	$('.menu-item-has-children')
		.on('mouseenter.submenu', function () {
			var subMenuHeight = $(this).find('.sub-menu li').length * 50;
			$(this).addClass('children-active');
			$(this).find('.sub-menu').css({ height: subMenuHeight });
		})
		.on('mouseleave.submenu', function () {
			$(this).removeClass('children-active');
			$(this).find('.sub-menu').css({ height: 0 });
		});

	var scrollMagicController = new ScrollMagic.Controller();

	// if ($(window).width() >= 1024 && $('.sticky').length > 0) {

	// 	new ScrollMagic.Scene({
	// 		triggerHook: 0,
	// 		triggerElement: '.sticky',
	// 		duration: 900
	// 	})
	// 		.setPin(".sticky")
	// 		.addTo(scrollMagicController);

	// 	new ScrollMagic.Scene({
	// 		triggerHook: 0,
	// 		triggerElement: '.sticky',
	// 		duration: 900
	// 	})
	// 		.setClassToggle('.using-the-app__step--1,', 'using-the-app__step--active')
	// 		.addTo(scrollMagicController);

	// 	new ScrollMagic.Scene({
	// 		triggerHook: 0,
	// 		offset: 300,
	// 		triggerElement: '.sticky',
	// 		duration: 900
	// 	})
	// 		.setClassToggle('.using-the-app__step--2', 'using-the-app__step--active')
	// 		.addTo(scrollMagicController);

	// 	new ScrollMagic.Scene({
	// 		triggerHook: 0,
	// 		offset: 600,
	// 		triggerElement: '.sticky',
	// 		duration: 900
	// 	})
	// 		.setClassToggle('.using-the-app__step--3', 'using-the-app__step--active')
	// 		.addTo(scrollMagicController);

	// }

	if ($(window).width() >= 1024 && $('.service-intro__illustration').length > 0) {
		var stickyLength = $('.service-intro__steps').height() / 1.5;

		new ScrollMagic.Scene({
			triggerHook: 0.1,
			triggerElement: '.service__intro',
			duration: stickyLength,
		})
			.setPin('.service-intro__illustration')
			.addTo(scrollMagicController);
	}

	if ($(window).width() >= 1024 && $('.city-golf-image').length > 0) {
		var stickyLength = $('.partners-intro__content').height() * 1.5;

		new ScrollMagic.Scene({
			triggerHook: 0.1,
			triggerElement: '.trigger',
			duration: stickyLength,
		})
			.setPin('.city-golf-image')
			.addTo(scrollMagicController);
	}

	if ($('.stats').length > 0) {
		var statsAnimation = new ScrollMagic.Scene({
			triggerHook: 0.4,
			triggerElement: '.stats',
		})
			.setClassToggle('.stats', 'in-view')
			.addTo(scrollMagicController);
	}

	if ($('.scaleImg').length > 0) {
		$('.scaleImg').each(function () {
			var scaleImg = TweenMax.fromTo(
				this,
				1.5,
				{
					scale: 1.14,
				},
				{
					scale: 1,
				}
			);

			var scaleImgScene = new ScrollMagic.Scene({
				triggerHook: 0.5,
				triggerElement: this,
				reverse: true,
			})
				// .addIndicators()
				.setTween(scaleImg)
				.addTo(scrollMagicController);
		});
	}

	$('.timeline').slick({
		centerPadding: '65px',
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		appendArrows: '.timeline__drag-wrapper .arrows',
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.timeline__item',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 787,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.timeline--charity').slick({
		centerPadding: '65px',
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		appendArrows: '.timeline__drag-wrapper--charity .arrows',
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.timeline__item',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 787,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// run a check of how many slides are shown in charity slider
	var slides = $('.timeline--charity .timeline__item').length;
	// if 2 slides add css class to timeline--charity
	if (slides <= 2 && $(window).width() > 787) {
		// hide arrow section on desktop
		$('.timeline__drag-wrapper--charity').hide();
		// turn on active class equivelant
		$('.timeline--charity .timeline__item:not(.slick-current)').addClass('slick-current');
	}

	$('#grab-slider__slick').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		adaptiveHeight: false,
		slide: '.grab-slider__item',
		appendDots: '.grab-slider__dots',
		rows: 0,
	});

	$('.testimonials__slider--global').slick({
		centerPadding: '75px',
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		appendArrows: '.testimonials-slider__arrows',
		dots: true,
		appendDots: '.testimonials-slider__dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.testimonials-slider__item',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: false,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 787,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.testimonials__slider--medical').slick({
		centerPadding: '75px',
		infinite: true,
		appendArrows: '.testimonials-slider__arrows',
		dots: true,
		appendDots: '.testimonials-slider__dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.testimonials-slider__item',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: false,
	});

	$('.city-connect__banner-slider').slick({
		adaptiveHeight: true,
		slidesToScroll: 1,
		infinite: true,
		appendArrows: '.city-connect__banner-arrows',
		dots: true,
		appendDots: '.city-connect__banner-dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.city-connect__banner-slide',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: false,
	});

	$('.card-slider__slider--2')
		.slick({
			centerPadding: '100px',
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: true,
			appendDots: '.card-slider__dots',
			autoplay: true,
			autoplaySpeed: 3000,
			slide: '.card-slider__item',
			pauseOnHover: false,
			rows: 0,
			responsive: [
				{
					breakpoint: 787,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		})
		.on('setPosition', function (event, slick) {
			slick.$slides.css('height', slick.$slideTrack.height() + 'px');
		});

	$('.card-slider__slider--3')
		.slick({
			centerPadding: '100px',
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: true,
			appendDots: '#card-slider__dots--3',
			autoplay: true,
			autoplaySpeed: 3000,
			slide: '.card-slider__item',
			pauseOnHover: false,
			rows: 0,
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 787,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		})
		.on('setPosition', function (event, slick) {
			slick.$slides.css('height', slick.$slideTrack.height() + 'px');
		});

	$('.card-slider__slider--values-mobile').slick({
		centerPadding: '100px',
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		dots: true,
		appendDots: '#card-slider__dots--values',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.card-slider__item',
		pauseOnHover: false,
		rows: 0,
	});

	$('.card-slider__slider--values-desktop').slick({
		centerPadding: '100px',
		infinite: true,
		arrows: false,
		dots: true,
		appendDots: '#card-slider__dots--values',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.card-slider__item',
		pauseOnHover: false,
		rows: 2,
		slidesPerRow: 3,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$('.service-slider__slider').slick({
		centerPadding: '130px',
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		appendArrows: '.service-slider__arrows',
		dots: true,
		appendDots: '.service-slider__dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.service-slider__item',
		pauseOnHover: false,
		rows: 0,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.academy-gallery__slider').slick({
		centerPadding: '130px',
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		appendArrows: '.academy-gallery__arrows',
		dots: true,
		appendDots: '.academy-gallery__dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.academy-gallery__item',
		pauseOnHover: false,
		rows: 0,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.gallery-slider').slick({
		centerPadding: '75px',
		infinite: true,
		appendArrows: '.gallery-slider__arrows',
		prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M18 31L2 15.704 16.334 2" stroke="#000" stroke-width="3.5" fill="none" fill-rule="evenodd" stroke-linejoin="round"/></svg></button>',
		nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M2 2l16 15.296L3.666 31" stroke="#000" stroke-width="3.5" fill="none" fill-rule="evenodd" stroke-linejoin="round"/></svg></button>',
		dots: true,
		appendDots: '.gallery-slider__dots',
		autoplay: true,
		autoplaySpeed: 3000,
		slide: '.gallery-slider__item',
		pauseOnHover: false,
		rows: 0,
		adaptiveHeight: false,
	});

	$('.values-block__card-slider__slider')
		.slick({
			centerPadding: '100px',
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: true,
			appendDots: '#values-block__card-slider__dots--3',
			autoplay: true,
			autoplaySpeed: 3000,
			slide: '.values-block__card-slider__item',
			pauseOnHover: false,
			rows: 0,
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 787,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

	// $('.partner-logos .btn').on('click', function (e) {
	// 	e.preventDefault();

	// 	$('.partner-logos__logos').toggleClass('partner-logos__logos--more');
	// });

	$('.partner-logos__loadmore').on('click', function () {
		$('.partner-logos__logos').toggleClass('partner-logos__logos--more');
	});

	$('.team__member').on('click', function (e) {
		e.preventDefault();

		$('body').addClass('no-scroll');
		$('.team-member-bio').addClass('team-member-bio--active');

		var data = {
			action: 'team_member_ajax',
			postID: $(this).attr('data-team-member'),
		};

		$.ajax({
			url: ajaxurl,
			data: data,
			success: function (data) {
				$('.team-member-bio').html(data);
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	});

	$('body').on('click', '.team-member-bio__close', function () {
		$('body').removeClass('no-scroll');
		$('.team-member-bio').removeClass('team-member-bio--active');
	});

	/*
	 ** Animations
	 */

	if ($('.fade-in-up').length > 0) {
		$('.fade-in-up').each(function () {
			var fadeInUp = TweenMax.fromTo(
				this,
				1.25,
				{
					autoAlpha: 0,
					y: 20,
				},
				{
					autoAlpha: 1,
					y: 0,
				}
			);

			var fadeInUpScene = new ScrollMagic.Scene({
				triggerHook: 0.8,
				triggerElement: this,
				reverse: true,
			})
				// .addIndicators()
				.setTween(fadeInUp)
				.addTo(scrollMagicController);
		});
	}

	/*
	 * Careers Role Toggle
	 */

	$('.role').on('click', function () {
		$(this).toggleClass('active');
		$(this).find('.role__description').slideToggle(300);
	});

	/*
	 * CV Upload
	 */

	$('.cv-upload-trigger').on('click', function () {
		$('.upload-trigger-wrap').fadeOut(400);
		setTimeout(function () {
			$('.careers-grav-form').fadeIn(600);
		}, 600);
	});

	/*
	 * Fixed button toggle
	 */

	$('.fixed-action .button').on('click', function () {
		$('.fixed-action').addClass('active');
	});

	$('.close-fixed-action').on('click', function () {
		$('.fixed-action').removeClass('active');
	});

	$('.team-item__more').on('click', function (e) {
		e.preventDefault();

		$('.team__member-details').addClass('active');

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'post',
			data: {
				action: 'teamDataFunction',
				id: $(this).data('team-id'), // you can retrieve this using $_POST['id'];
			},
			success: function (data) {
				// returned data by wordpress

				$('.team__member-details .content').append(data);
			},
		});
	});

	$('.team__member-details .content .close-btn').on('click', function () {
		$('.team__member-details').removeClass('active');
		$('.team__member-details .team-text').remove();
		$('.team__member-details .team-image').remove();
	});
});

var stats_slider_settings = {
	mobileFirst: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	// centerMode: true,
	infinite: false,
	arrows: false,
	dots: true,
	appendDots: '.stats__slider-dots',
	draggable: true,
	autoplay: true,
	autoplaySpeed: 3000,
	slide: '.stats__item',
	pauseOnHover: false,
	rows: 0,
	responsive: [
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 1024,
			settings: 'unslick',
		},
	],
};

function windowResize() {
	if ($(window).width() < 1024 && !$('.stats .flex').hasClass('slick-initialized')) {
		$('.stats .flex').slick(stats_slider_settings);
	}
}

var lastScrollTop = 0;

$(window).scroll(function (event) {
	var st = $(this).scrollTop();
	var windownHeight = $(window).height();
	if (st > lastScrollTop && st >= 30) {
		// downscroll code
		if (!$('.nav-wrapper').hasClass('nav-wrapper--open')) {
			$('.header, .header__burger').removeClass('slide-down');
			$('.header, .header__burger').addClass('slide-up');
		}
		if (st >= windownHeight) {
			$('.header').addClass('header--fill');
			$('.nav-wrapper').addClass('nav-wrapper--scrolled');
		} else {
			$('.header').removeClass('header--fill');
			$('.nav-wrapper').removeClass('nav-wrapper--scrolled');
		}
	} else {
		// upscroll code
		$('.header, .header__burger').removeClass('slide-up');
		$('.header, .header__burger').addClass('slide-down');
		$('.nav-wrapper').addClass('nav-wrapper--scrolled');

		if (st < windownHeight) {
			$('.header').removeClass('header--fill');
			$('.header__burger').removeClass('slide-down');
			$('.nav-wrapper').removeClass('nav-wrapper--scrolled');
		}
	}
	lastScrollTop = st;
});

// Google Maps
function new_map($el) {
	// var
	var $markers = $el.find('.marker');

	// vars
	var args = {
		// zoom: 22,
		maxZoom: 14,
		center: new google.maps.LatLng(0, 0),
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: [
			{
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#616161',
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						color: '#f5f5f5',
					},
				],
			},
			{
				featureType: 'administrative.land_parcel',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#bdbdbd',
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#eeeeee',
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#757575',
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e5e5e5',
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#9e9e9e',
					},
				],
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#757575',
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dadada',
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#616161',
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#9e9e9e',
					},
				],
			},
			{
				featureType: 'transit.line',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e5e5e5',
					},
				],
			},
			{
				featureType: 'transit.station',
				elementType: 'geometry',
				stylers: [
					{
						color: '#eeeeee',
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#05D1EB',
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#05D1EB',
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#9e9e9e',
					},
				],
			},
		],
	};

	// create map
	var map = new google.maps.Map($el[0], args);

	// add a markers reference
	map.markers = [];

	// add markers
	$markers.each(function () {
		add_marker($(this), map);
	});

	// center map
	center_map(map);

	// return
	return map;
}

/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$marker (jQuery element)
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function add_marker($marker, map) {
	// var
	var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

	// icon
	var icon = {
		url: '/wp-content/themes/Fishtank/assets/img/map-icon.png',
		scaledSize: new google.maps.Size(62, 72),
	};

	// create marker
	var marker = new google.maps.Marker({
		id: $marker.attr('data-name'),
		position: latlng,
		map: map,
		content: $marker.html(),
		icon: icon,
	});

	// add to array
	map.markers.push(marker);

	// if marker contains HTML, add it to an infoWindow
	if ($marker.html()) {
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content: $marker.html(),
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function () {
			infowindow.open(map, marker);
		});
	}
}

/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function center_map(map) {
	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each(map.markers, function (i, marker) {
		var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

		bounds.extend(latlng);
	});

	// only 1 marker?
	if (map.markers.length == 1) {
		// set center of map
		map.setCenter(bounds.getCenter());
		map.setZoom(22);
	} else {
		// fit to bounds
		map.fitBounds(bounds, 80);
		// map.setCenter( {lat: 51.608731, lng: -0.018623} );
		// map.setZoom( 16 );
	}
}

/*
 *  document ready
 *
 *  This function will render each map when the document is ready (page has loaded)
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	5.0.0
 *
 *  @param	n/a
 *  @return	n/a
 */
// global var
var map = null;

$(document).ready(function () {
	$('.map').each(function () {
		// create map
		map = new_map($(this));
	});
});
